export default __webpack_public_path__ + "static/3-9b932c0e855978bded671c6450cc052c.jpg";